import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=ef0422de&scoped=true&"
import script from "./CategoryItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0422de",
  null
  
)

export default component.exports